import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Bullets() {
  const items = ['Get up to 3 quotes in minutes', 'Verified companies near you', 'No annoying calls', 'No cost to compare', 'Your data stays private'];
  return <section className="bg-gray-50 border-y border-gray-100 py-10 px-4" data-id="element-11">
      <div className="max-w-7xl mx-auto" data-id="element-12">
        <div className="flex flex-wrap justify-center gap-4 md:gap-6" data-id="element-13">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className="flex items-center space-x-3 bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex-grow sm:flex-grow-0" data-id="element-14">
              <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-15" />
              <span className="text-gray-800 font-medium text-base whitespace-nowrap" data-id="element-16">
                {item}
              </span>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}